import { z } from 'zod';

export const BOT_PREFERENCES_STORAGE_KEY = 'towerarena.com.bot-preferences';

export interface BotPreferences {
  readonly schemaVersion: 1;
  readonly botId: string;
}

const schema = z.object({ schemaVersion: z.literal(1), botId: z.string().min(1) });

export function parseBotPreferences(raw: string | null, availableBotIds: ReadonlySet<string>, defaultBotId: string): { preferences: BotPreferences; repaired: boolean } {
  if (!raw) return { preferences: { schemaVersion: 1, botId: defaultBotId }, repaired: false };
  try {
    const parsed = schema.parse(JSON.parse(raw));
    if (!availableBotIds.has(parsed.botId)) return { preferences: { schemaVersion: 1, botId: defaultBotId }, repaired: true };
    return { preferences: parsed, repaired: false };
  } catch {
    return { preferences: { schemaVersion: 1, botId: defaultBotId }, repaired: true };
  }
}

export function saveBotPreferences(storage: Pick<Storage, 'setItem'>, preferences: BotPreferences): boolean {
  try {
    storage.setItem(BOT_PREFERENCES_STORAGE_KEY, JSON.stringify(preferences));
    return true;
  } catch {
    return false;
  }
}
